import { memo, type PropsWithChildren, type ReactNode, type Ref } from 'react';

import { TopBar } from '~/_components/TopBar';
import { PrivateHeaderActions } from '~/components/Shared/HeaderBar/PrivateHeaderActions';

export type PrivateHeaderBarProps = {
  headerActions?: ReactNode;
  footer?: ReactNode;
  headerRef?: Ref<HTMLDivElement>;
};

export const PrivateHeaderBar = memo(
  ({ headerActions, footer, headerRef, children }: PropsWithChildren<PrivateHeaderBarProps>) => {
    return (
      <TopBar className="bg-grey-1 pt-2 pb-0 md:pt-4 md:pb-0" ref={headerRef}>
        <div className="w-full">
          <div className="flex w-full justify-between gap-8 pb-2">
            <div className="w-full">{children}</div>
            <PrivateHeaderActions actions={headerActions} />
          </div>
          {footer}
        </div>
      </TopBar>
    );
  },
);

PrivateHeaderBar.displayName = 'PrivateHeaderBar';
